 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + {"chunk-0b037a24":"efd70e4c","chunk-13510428":"2f9f7894","chunk-142563fa":"e419eb37","chunk-36e63296":"cbbda44c","chunk-3da552ad":"6729cd1c","chunk-0af6a07b":"e2706687","chunk-611c213c":"dcf6ffbf","chunk-2d069e6b":"f84f5e17","chunk-3e299a38":"61e3bead","chunk-6f86c20a":"93a4e142","chunk-95b43644":"3f227520","chunk-e593bade":"83638647","chunk-b9ec4490":"9e69614d","chunk-a40ae960":"08b51bcc","chunk-5fab8a92":"7a992168","chunk-74471a6e":"b30b40d2","chunk-c91ce24e":"147ceb6c","chunk-ce8b6022":"fa96c63c","chunk-47820dd6":"b5b75da9","chunk-4b6cc3ba":"3eddd4f1","chunk-54239a8e":"a22cbc63","chunk-551f4345":"f3640cfa","chunk-59799c3b":"61ad64d0","chunk-5a8d37be":"aec3c67c","chunk-5c790d61":"8d06cacd","chunk-5faff37e":"c2116d01","chunk-7980c3b8":"2f9af4d0","chunk-7ab444ac":"0f62e3e3","chunk-cc47f130":"d769c13a","chunk-ee63e24c":"d4780f2b","chunk-14bc3f0c":"6ab6ac00","chunk-201c62bc":"9f58158d","chunk-2d2223ef":"526b0e98","chunk-4c0dd6c9":"890d5f0f","chunk-510346b1":"5d83f5e9","chunk-743c2ddb":"776715f1","chunk-745a3122":"b38b383d","chunk-7467d5b8":"487b1354","chunk-7482e5bc":"61cb5df8","chunk-74af77ea":"85df14ba","chunk-74b7681c":"918ce06a","chunk-74bb0962":"b32a316c","chunk-76f042f8":"6bc3b93c","chunk-774c8cf7":"aa91818a"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-0b037a24":1,"chunk-13510428":1,"chunk-142563fa":1,"chunk-36e63296":1,"chunk-3da552ad":1,"chunk-0af6a07b":1,"chunk-611c213c":1,"chunk-2d069e6b":1,"chunk-3e299a38":1,"chunk-6f86c20a":1,"chunk-95b43644":1,"chunk-e593bade":1,"chunk-b9ec4490":1,"chunk-a40ae960":1,"chunk-5fab8a92":1,"chunk-74471a6e":1,"chunk-c91ce24e":1,"chunk-ce8b6022":1,"chunk-47820dd6":1,"chunk-4b6cc3ba":1,"chunk-54239a8e":1,"chunk-551f4345":1,"chunk-59799c3b":1,"chunk-5a8d37be":1,"chunk-5c790d61":1,"chunk-5faff37e":1,"chunk-7980c3b8":1,"chunk-7ab444ac":1,"chunk-cc47f130":1,"chunk-ee63e24c":1,"chunk-14bc3f0c":1,"chunk-201c62bc":1,"chunk-4c0dd6c9":1,"chunk-510346b1":1,"chunk-743c2ddb":1,"chunk-745a3122":1,"chunk-7467d5b8":1,"chunk-7482e5bc":1,"chunk-74af77ea":1,"chunk-74b7681c":1,"chunk-74bb0962":1,"chunk-76f042f8":1,"chunk-774c8cf7":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "." + {"chunk-0b037a24":"a280000d","chunk-13510428":"88b910f9","chunk-142563fa":"311f4651","chunk-36e63296":"d92f759b","chunk-3da552ad":"750c0205","chunk-0af6a07b":"3f168431","chunk-611c213c":"c46b84e8","chunk-2d069e6b":"78d7b6db","chunk-3e299a38":"9bb8e44f","chunk-6f86c20a":"e36a9507","chunk-95b43644":"122dcd13","chunk-e593bade":"5cab5d84","chunk-b9ec4490":"8dd1afeb","chunk-a40ae960":"d3aca9de","chunk-5fab8a92":"38bad8fc","chunk-74471a6e":"d4902001","chunk-c91ce24e":"b1fa861b","chunk-ce8b6022":"0f1abd28","chunk-47820dd6":"1aba7a05","chunk-4b6cc3ba":"edd91ba5","chunk-54239a8e":"fef35e0d","chunk-551f4345":"875129f3","chunk-59799c3b":"aa2ab5ef","chunk-5a8d37be":"fef35e0d","chunk-5c790d61":"dc45abfc","chunk-5faff37e":"b90b99cc","chunk-7980c3b8":"78d7b6db","chunk-7ab444ac":"5fa2761b","chunk-cc47f130":"20bd3869","chunk-ee63e24c":"3a4a1d1f","chunk-14bc3f0c":"57c01be0","chunk-201c62bc":"a6a6a033","chunk-2d2223ef":"31d6cfe0","chunk-4c0dd6c9":"64023625","chunk-510346b1":"417c6c07","chunk-743c2ddb":"0dd2478f","chunk-745a3122":"d7dc1639","chunk-7467d5b8":"97906909","chunk-7482e5bc":"3fc962f4","chunk-74af77ea":"23b17eb2","chunk-74b7681c":"6ff76692","chunk-74bb0962":"06c127ee","chunk-76f042f8":"a3d504dc","chunk-774c8cf7":"93e9293c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://presenter.ahaslides.com/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
